import React from 'react';
import classes from './spinner.module.css';

const Spinner = ({
  overlayText = null,
  message = "We are hard at work creating your content. This may take a few minutes."
}) => {
  const displayMessage = (message && message.trim()) || "We are hard at work creating your content. This may take a few minutes.";
  
  return (
    <div className={classes["spinner-overlay"]} role="progressbar" aria-label="Loading">
      <div className={classes.spinner}></div>
      <div className={classes.text}>
        {displayMessage}
      </div>
      {overlayText ? <div className={classes.text}>{overlayText}</div> : null}
    </div>
  );
};

const PageLoadingSpinner = ({
  overlayText = null,
  message = ""
}) => {
  return (
    <div className={classes["spinner-overlay"]} role="progressbar" aria-label="Loading page">
      <div className={classes.spinner}></div>
      <div className={classes.text}>
        {message}
      </div>
      {overlayText ? <div className={classes.text}>{overlayText}</div> : null}
    </div>
  );
};

const InlineSpinner = ({
  overlayText = null,
  message = "We are hard at work creating your content. This may take a few minutes."
}) => {
  const displayMessage = (message && message.trim()) || "We are hard at work creating your content. This may take a few minutes.";
  
  return (
    <div className={classes.spinnerContainer} role="progressbar" aria-label="Loading content">
      <div className={classes.spinnerBuffer}>
        <div className={classes.spinner}></div>
      </div>
      <div className={classes.inlineText}>
        {displayMessage}
      </div>
      {overlayText ? <div className={classes.inlineText}>{overlayText}</div> : null}
    </div>
  );
};

export default Spinner;
export { InlineSpinner };
export {PageLoadingSpinner}